<table>
    <tr>
        <td>Flight Details:
            {{departureVM.departureCode}}&nbsp;{{departureVM.arrivalStation}}&nbsp;{{departureVM.terminalName}}
        </td>
        <td>Status: {{departureVM.status}}</td>
        <td>Scheduled: {{departureVM.scheduledDeparture | date: 'yyyy-MM-dd HH:mm'}}</td>
        <td>Estimated: {{departureVM.estimatedDeparture | date: 'yyyy-MM-dd HH:mm'}}</td>
        <td>Actual: {{departureVM.actualDeparture | date: 'yyyy-MM-dd HH:mm'}}</td>
        <td>Gate: {{departureVM.gate}}</td>
        <td>Desk: {{departureVM.checkInDeskFrom}} - {{departureVM.checkInDeskTo}} {{departureVM.checkInStatus}}</td>
    </tr>
</table>